import { render, staticRenderFns } from "./bottom-right.vue?vue&type=template&id=6978a18c&scoped=true&"
import script from "./bottom-right.vue?vue&type=script&lang=js&"
export * from "./bottom-right.vue?vue&type=script&lang=js&"
import style0 from "./bottom-right.vue?vue&type=style&index=0&id=6978a18c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978a18c",
  null
  
)

export default component.exports